module.exports = __webpack_public_path__ + "b89e0d8.woff2";